// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    button: {
        field: {
            enabled: true,
            scaling: 0,
        },
    },
    category: {
        image: {
            small: getImageSize(768),
            large: getImageSize(1410, 550),
        },
    },
    form: {
        actions: {
            gap: pxToRem(8),
            spacing: "1.6em",
        },
        fields: {
            spacing: "1em",
        },
        grid: {
            small: {
                horizontal: pxToRemArray([20]),
                vertical: ["0.75em"],
            },
            base: {
                horizontal: pxToRemArray([30]),
                vertical: ["1em"],
            },
        },
    },
    layout: {
        contentWidth: 1410,
        spacing: {
            side: pxToRemArray([20, 30, 45, 45, 60]),
            content: pxToRemArray([25, 30, 45, 60, 60]),
            /* Store Custom Code - Start (spacing based on the styleguide) */
            tiny: pxToRem(4),
            smallest: pxToRem(8),
            smaller: pxToRem(12),
            small: pxToRem(16),
            base: pxToRem(24),
            large: pxToRem(32),
            larger: pxToRem(48),
            largest: pxToRem(64),
            big: pxToRem(80),
            /* Store Custom Code - End */
        },
    },
    menu: {
        mobileButtonPadding: pxToRem(10),
    },
    product: {
        image: {
            small: getImageSize(285),
            medium: getImageSize(570),
            large: getImageSize(855),
        },
        detail: {
            contentSpacing: pxToRem(16),
        },
        list: {
            contentSpacing: pxToRem(10),
        },
    },
    typography: {
        fontFamily: {
            title: `Arial`,
            base: `Arial`,
        },
        letterSpacing: {
            base: pxToRem(0),
            large: pxToRem(0.5),
            larger: pxToRem(1),
        },
        lineHeight: {
            smaller: 1,
            small: 1.25,
            semi: 1.375,
            base: 1.5,
            large: 1.75,
            larger: 2,
        },
        size: {
            tiny: pxToRem(12),
            smallest: pxToRem(13),
            smaller: pxToRem(14),
            small: pxToRem(15),
            base: pxToRem(16),
            large: pxToRem(18),
            larger: pxToRem(20),
        },
        spacing: {
            smaller: "0.25em",
            small: "0.5em",
            base: "1em",
            large: "1.5em",
            larger: "2em",
        },
        weight: {
            thin: 100,
            extralight: 200,
            light: 300,
            base: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
            extrabold: 800,
            black: 900,
        },
    },
    /* Store Custom Code - Start */
    radius: {
        small: pxToRem(6),
        medium: pxToRem(10),
        large: pxToRem(24),
    }
    /* Store Custom Code - End */
};

export default design;
